import { render, staticRenderFns } from "./BnetIdentifierSelect.vue?vue&type=template&id=1c8f9422&"
import script from "./BnetIdentifierSelect.vue?vue&type=script&lang=js&"
export * from "./BnetIdentifierSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports